import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
  category: Category;
};

export const getImpactCo2AnswersForCategory = createAppAsyncThunk(
  'impactCo2/getImpactCo2AnswersForCategory',
  async (
    params: Params,
    { extra: { impactCo2Gateway, snackbarGateway } },
  ): Promise<ImpactCo2Answer[]> => {
    try {
      const answers = await impactCo2Gateway.getImpactAnswersForCategory(
        params.projectId,
        params.category,
      );
      return answers;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCo2Answers.Message.error'));
}
